import type { DynamicIslandActivity } from '../../../../context/dynamicIslandTypes'
import { getActivitySoloPresentation } from '../../../../lib/dynamicIsland/activitySoloPresentation'
import {
  dynamicIslandAccentClass,
  dynamicIslandProgressFillClass,
  dynamicIslandProgressTrackClass,
} from '../../../../lib/dynamicIsland/dynamicIslandPresentation'

type Props = {
  activity: DynamicIslandActivity
  angular: boolean
  onExpand: () => void
}

export function DynamicIslandSoloPreview({ activity, angular, onExpand }: Props) {
  const solo = getActivitySoloPresentation(activity)
  const progressTrack = dynamicIslandProgressTrackClass(angular)
  const progressFill = dynamicIslandProgressFillClass({
    accent: solo.accent,
    progressPercent: solo.progressPercent ?? 0,
  })
  const ariaLabel = [solo.sourceLabel, solo.title, solo.subtitle].filter(Boolean).join('，')

  return (
    <button
      type="button"
      className="glyphicai-dynamic-island-solo-trigger"
      aria-label={ariaLabel}
      aria-expanded={false}
      onClick={(e) => {
        e.stopPropagation()
        onExpand()
      }}
    >
      <span
        className={['glyphicai-dynamic-island-activity__accent', dynamicIslandAccentClass(solo.accent)].join(' ')}
        aria-hidden
      />
      <span className="glyphicai-dynamic-island-solo-trigger__body">
        <span className="glyphicai-dynamic-island-solo-trigger__meta">
          <span className="glyphicai-dynamic-island-solo-trigger__title">{solo.title}</span>
          {solo.subtitle ? (
            <span className="glyphicai-dynamic-island-solo-trigger__subtitle">{solo.subtitle}</span>
          ) : null}
        </span>
        {solo.showProgress && solo.progressPercent != null ? (
          <span className={['glyphicai-dynamic-island-solo-trigger__progress', progressTrack].join(' ')}>
            <span
              className={['glyphicai-dynamic-island-activity__progress-fill', progressFill].join(' ')}
              style={{ width: `${solo.progressPercent}%` }}
            />
          </span>
        ) : null}
      </span>
    </button>
  )
}
